var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "section",
        { staticStyle: { width: "100%", height: "100%" } },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c("copyright-message"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }